import { ArrowRightIcon, DepositIcon } from "@xola/icons";
import React from "react";
import { Audit, LineItem, LineItemType, Purchase, PurchaseItem } from "types";
import { Currency } from "@/components/Common/Currency";
import { TimelineItem, TimelinePill } from "@/components/PurchasesMenu/Timeline/TimelineItem";

interface GratuityModifiedTimelineProps {
    showDate?: boolean;
    item: PurchaseItem;
    change: Audit;
}

interface AuditItem {
    id: ID;
    amount: { old: number; new: number };
    lineItems: Partial<AuditItem>[];
}
export const GratuityModifiedTimelineItem = ({ showDate = false, item, change }: GratuityModifiedTimelineProps) => {
    const auditItem = Object.values<AuditItem>(change.data.items).find((_item) => _item.id === item.id);
    const gratuityLineItemIndex = item.lineItems.findIndex(
        (lineItem: LineItem) => lineItem.type === LineItemType.GRATUITY,
    );
    const gratuityData = auditItem?.lineItems?.[gratuityLineItemIndex];
    return (
        <TimelineItem
            title="Gratuity Modified"
            audit={change}
            icon={<DepositIcon />}
            color="success"
            showDate={showDate}
        >
            <div className="text-sm text-gray-darker">
                <Currency shouldRemoveTrailingZeroes={false}>{gratuityData?.amount?.new}</Currency>
            </div>
            <TimelinePill className="!ml-0">
                <Currency shouldRemoveTrailingZeroes={false}>{gratuityData?.amount?.old}</Currency>
            </TimelinePill>
            <ArrowRightIcon />
            <TimelinePill>
                <Currency shouldRemoveTrailingZeroes={false}>{gratuityData?.amount?.new}</Currency>
            </TimelinePill>
        </TimelineItem>
    );
};

GratuityModifiedTimelineItem.supportsAudit = (_purchase: Purchase, _item: PurchaseItem, _audit: Audit) => {
    if ("items" in _audit.data) {
        const gratuityLineItemIndex = _item.lineItems.findIndex((lineItem) => lineItem.type === LineItemType.GRATUITY);
        return _audit.data.items.some((item: AuditItem) => {
            return (
                item.id === _item.id &&
                !!item.lineItems &&
                gratuityLineItemIndex in item.lineItems &&
                "amount" in item.lineItems[gratuityLineItemIndex]
            );
        });
    }
    return false;
};
